// extracted by mini-css-extract-plugin
export default {"title":"LevelUpReward_title__BX--5"};